import React, { JSX, useEffect, useState } from 'react';
import numeral from 'numeral';
import './app.scss';
import { initializeAmplify } from '../utils/amplify';
import { checkConfigDetailsInStorage, genericLogout } from './appHelper';
import { ObjectUtil } from 'helper-util';
import {
  getStringFromStorage,
  setObjectInStorage,
  setStringInStorage,
} from '../services/storageService';
import { setAuthExpiryTime } from '../utils/auth';
import { authLogout } from './appActions';
import { activeClientConfig } from '../services/authService';
import { Config } from '../constants/clientConfig';
import { useDispatch, useSelector } from 'react-redux';
import { getThemeFromLs } from '../utils/featureUtils';
import { setDarkTheme } from './appSlice';
import NavigationBar from '../features/navigationBar/navigationBarComponent';
import { LicenseManager } from 'ag-grid-enterprise';
import { apiConfig } from '../config/apiConfig';
import { paths } from '../routes/routesConfig';
import Routes from '../routes/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorBoundary from '../pages/errorHandler/errorBoundary';
import ErrorHandler from '../pages/errorHandler/errorComponent';
import ToastNotification from '../features/toastNotification/toastNotificationComponent';
import WebSocketNotification from '../features/webSocket/webSocketContainer';

function App(): JSX.Element {
  const [token, setToken] = useState(Boolean(getStringFromStorage('authTokenKey')));
  const errorMessage = useSelector((state: RootState) => state.error.msg);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    const { amplifyConfig, tenant } = checkConfigDetailsInStorage();
    const clientConfig = getStringFromStorage(activeClientConfig);

    if (!ObjectUtil.isEmpty(amplifyConfig)) {
      initializeAmplify(amplifyConfig, tenant, false);
      setObjectInStorage('amplifyConfig', amplifyConfig);
      setStringInStorage('tenant', tenant);
    } else {
      setToken(true);
    }

    setAuthExpiryTime(null, history, (resolved, token) => {
      if (resolved) {
        setToken(!!token);
      } else {
        genericLogout(() => dispatch(authLogout()), navigate);
      }
    });

    if (clientConfig) {
      Config.setActiveConfig = clientConfig;
    }

    const theme = getThemeFromLs();
    dispatch(setDarkTheme({ isDark: theme === 'dark' }));
    document.getElementsByTagName('html')[0].setAttribute('data-theme', theme);
    LicenseManager.setLicenseKey(apiConfig.agGridKey);

    numeral.locale('en_US');
  }, []);

  const excludedPaths = new Set([
    '/',
    paths.login,
    paths.changePassword,
    paths.forgotPassword,
    paths.resetPassword.split('/')[1],
  ]);

  const { pathname } = useLocation();
  const showNavigation = !excludedPaths.has(pathname);
  const showNotifications = ![paths.login, '/'].includes(pathname);
  return (
    <>
      {showNotifications && (
        <>
          <ToastNotification />
          <WebSocketNotification />
        </>
      )}
      {showNavigation && <NavigationBar />}
      <div className="px-0 pb-0" id="module">
        <ErrorBoundary>
          {errorMessage && <ErrorHandler />}
          <Routes />
        </ErrorBoundary>
      </div>
    </>
  );
}

export default App;
